import { render, staticRenderFns } from "./AlphabetTabs.vue?vue&type=template&id=483764d0&scoped=true&"
import script from "./AlphabetTabs.vue?vue&type=script&lang=js&"
export * from "./AlphabetTabs.vue?vue&type=script&lang=js&"
import style0 from "./AlphabetTabs.vue?vue&type=style&index=0&id=483764d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483764d0",
  null
  
)

export default component.exports